export default {
  items: [
    {
      name: 'ホーム',
      url: '/Home',
      icon: 'icon-home'
    },
    {
      name: '物件管理',
      url: '/Plan',
      icon: 'icon-folder-alt'
    },
    {
      name: '利用状況',
      url: '/State',
      icon: 'icon-speech'
    },
    {
      name: '集計',
      url: '/Aggregate',
      icon: 'icon-chart'
    },
    {
      name: '利用者情報',
      url: '/UserInfo',
      icon: 'icon-user'
    },
    {
      name: 'プラン変更',
      url: '/Grade',
      icon: 'icon-credit-card'
    },
    {
      name: 'ログアウト',
      icon: 'icon-logout',
      button: 'logout'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_cpunav.js